import { render, staticRenderFns } from "./TrafficSources.vue?vue&type=template&id=bddec1e8"
import script from "./TrafficSources.vue?vue&type=script&lang=js"
export * from "./TrafficSources.vue?vue&type=script&lang=js"
import style0 from "./TrafficSources.vue?vue&type=style&index=0&id=bddec1e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports